import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { TripForm } from '../components/TripForm';
import type { CreateTripData } from '../types';
import * as tripService from '../services/tripService';

export function CreateTripPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: CreateTripData) => {
    setIsSubmitting(true);
    try {
      const trip = await tripService.createTrip(data as CreateTripData);
      navigate(`/trips/${trip.id}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Nova Trip
      </Typography>
      <Paper sx={{ p: 3 }}>
        <TripForm
          onSubmit={handleSubmit}
          onCancel={() => navigate('/trips')}
          isSubmitting={isSubmitting}
        />
      </Paper>
    </Box>
  );
}
